/* Generated by scripts/build-picker-icons.mjs. Do not edit directly. */
import type { PickerIconProps } from "../types.ts";

export function SymbolNavigationIcon({
  size = 24,
  color = "currentColor",
  title,
  ...svgProps
}: PickerIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      data-icon="symbol-navigation"
      data-variant="filled"
      role={title ? "img" : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
      <path d="M12 19.1L5 22.07Q4.58 22.25 4.2 22.16Q3.83 22.07 3.55 21.8Q3.27 21.52 3.17 21.14Q3.08 20.75 3.27 20.32L10.8 3.35Q10.97 2.95 11.3 2.75Q11.63 2.55 12 2.55Q12.38 2.55 12.7 2.75Q13.03 2.95 13.2 3.35L20.73 20.32Q20.93 20.75 20.82 21.14Q20.73 21.52 20.45 21.8Q20.18 22.07 19.8 22.16Q19.43 22.25 19 22.07Z" fill={color} />
    </svg>
  );
}
